export default __webpack_public_path__ + "static/media/portfolio-213.093cc98a.jpg";